import { useEffect, useState } from "react";
import Row from "@/components/wida/Row";
import Section from "@/components/wida/Section";
import AboutMe from "./AboutMe";
import Icon from "@/components/wida/Icon";
import Datas from "@/datas"
import Hover from "@/components/wida/Hover";

const { motos, socials, sillyFaces } = Datas

export default function Main() {
    const [openAboutMe, setOpenAboutMe] = useState(false);
    const [titleIndex, setTitleIndex] = useState(0);

    const title = "Yo, I'm Wida !"
    const links = [
        {
            name: "About",
            onClick: () => setOpenAboutMe(true)
        },
        {
            name: "Projects",
            onClick: () => document.getElementById("projects")?.scrollIntoView({ behavior: "smooth" })
        },
        {
            name: "Status",
            onClick: () => window.open("https://status.wida.dev", "_blank")
        }
    ]


    // Title's Typing Effect
    useEffect(() => {
        if (titleIndex >= title.length) return
        const timeout = setTimeout(() => {
            setTitleIndex(titleIndex + 1)
        }, 67)
        return () => clearTimeout(timeout)
    }, [titleIndex])
    
    // Generate a moto
    const [moto] = useState(() => {
        const date = new Date()
        const dateStr = date.getDate() + "/" + (date.getMonth() + 1)

        const item =
            motos.specials[dateStr] ??
            motos.default[Math.floor(Math.random() * motos.default.length)]

        const base = item()
        if (motos.specials[dateStr]) return base 

        const face = sillyFaces[Math.floor(Math.random() * sillyFaces.length)]
        return <> {base} {face} </>
    })

    return <Section>
        <div className="text-center">
            <h1 className="text-4xl font-bold leading-tight">{title.slice(0, titleIndex)}{titleIndex >= title.length ? "" : "|"}</h1>
            <p className="text-xl">{moto}</p>

            <Row className="text-xl mt-6 gap-6">
                {links.map((x, i) => <div className="cursor-pointer underline hover:text-white/70 transition-colors duration-200" onClick={x.onClick} key={i}>{x.name}</div>)}
            </Row>

            <Row className="text-xl mt-2">
                {socials.map((x, i) => 
                    <Hover key={i} description={x.name}>
                        <Icon path={x.icon} link={x.link} className="w-8 h-8 mx-4 my-3"></Icon>
                    </Hover>
                )}
            </Row>
            <AboutMe open={openAboutMe} setOpen={setOpenAboutMe}></AboutMe>
        </div>
    </Section>
}